export const GET_CURSOR = `
  query GetPosts($slug: String!) {
    posts(where: { name: $slug }) {
      edges {
        cursor
      }
    }
  }
`

const setVaiables = (cursor, category, author) => {
  const postsIds = `$postsIds: [ID] = []`

  if (cursor || category || author)
    return `(${cursor}${category}${author}, ${postsIds})`

  return `(${postsIds})`
}

export const GET_NEXT_POST = (hasCursor, hasCategory, hasAuthor) => `
  query GetPosts ${setVaiables(
    hasCursor && '$cursor: String!',
    hasCategory && ', $categorySlug: String!',
    hasAuthor && ', $authorId: [ID]',
  )} {
    posts(
      ${(hasCursor && 'after: $cursor') || ''}
      where: {
        ${(hasCategory && 'categoryName: $categorySlug') || ''}
        ${(hasAuthor && 'authorIn: $authorId') || ''}
        orderby: { field: DATE, order: DESC }
        notIn: $postsIds
      }
      first: 1
    ) {
      edges {
        node {
          id
          uri
          date
          title
          legacyContent: content
          author {
            details: node {
              id
              email
              firstName
              lastName
              name
              description
              authorUri: uri
              socialLinks {
                facebook
                instagram
                twitter
                linkedin
              }
              userSettings {
                profileImg {
                  altText
                  sourceUrl
                }
              }
              roles {
                roles: nodes {
                  name
                }
              }
            }
          }
          featuredImage {
            image: node {
              altText
              caption
              description
              sourceUrl
            }
          }
          postFlexContent {
            subheader
            customHeader
            headerType
            overrideTitle
            addBlock {
              ... on Post_Postflexcontent_AddBlock_Paragraph {
                content
                header
                size
                paragraphImage {
                  altText
                  description
                  sourceUrl
                }
              }
              ... on Post_Postflexcontent_AddBlock_Image {
                size
                image {
                  altText
                  caption
                  description
                  sourceUrl
                }
              }
              ... on Post_Postflexcontent_AddBlock_Quote {
                quote: content
              }
              ... on Post_Postflexcontent_AddBlock_Slideshow {
                slideshow {
                  image {
                    altText
                    sourceUrl
                    caption
                    description
                  }
                }
              }
            }
          }
          tags {
            tags: nodes {
              id
              uri
              name
            }
          }
          categories {
            cats: nodes {
              id
              uri
              name
            }
          }
        }
        cursor
      }
    }
  }
`
